
import { i18nText } from '@/locales';

import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Tabs} from "ant-design-vue";
import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {RouterNameEnum} from "@/router/router.types";
import {getStudioId} from "@/UI/lib/state";
import { checkUserRole, getUserData } from '@/router/Lib/helper';

@Component({
  components: {
    BaseDataForm,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
  },
  methods: {
    checkUserRole
  }
})
export default class LoayltyIndex extends mixins(SimpleProxyForm) {
  tabs = [
    {
      id: RouterNameEnum.LoyaltyCert,
      name: i18nText("Сертификаты"),
      meta: {
        alias: RouterNameEnum.LoyaltyCert,
      },
      params: {
        meta: {
          alias: RouterNameEnum.LoyaltyCert,
        },
        name: RouterNameEnum.LoyaltyCert,
        params: {Studio: getStudioId(this)},
      },
    },
    {
      id: RouterNameEnum.LoyaltyCertType,
      name: i18nText("Типы сертификатов"),
      meta: {
        alias: RouterNameEnum.LoyaltyCert,
      },
      params: {
        meta: {
          alias: RouterNameEnum.LoyaltyCert,
        },
        name: RouterNameEnum.LoyaltyCert,
        params: {Studio: getStudioId(this)},
      },
    },
  ];

  get activeTab(): string {
    return this.tabs.find(item => item.id === this.$route.name || item.id + 'Page' === this.$route.name)?.id || this.tabs[0].id;
  }

  tabChanged(key: string): void {
    this.$router.push({name: key, params: {Studio: getStudioId(this)}});
  }

  async created(): Promise<void> {
    this.formReady = true;
  }
}
